'use strict';

var jQuery = require('jquery');
window.jQuery = window.$ = jQuery;

window.scrollto = require('jquery.scrollto');

// require('./mobile.js');
require('./main.js');

var markBlock
var allMark = document.querySelectorAll('.js-mark');

if (allMark.length > 0) {
  require.ensure([], function() {
    markBlock = require('./mark');

    for (var i = 0; i < allMark.length; i++) {
      markBlock(allMark[i]);
    }
  }, 'mark');
}


var commentMarkBlock
var allCommentMark = document.querySelectorAll('.js-comment_mark');

if (allMark.length > 0) {
  require.ensure([], function() {
    commentMarkBlock = require('./comment_mark');

    for (var i = 0; i < allCommentMark.length; i++) {
      commentMarkBlock(allCommentMark[i]);
    }
  }, 'comment_mark');
}


var downloadBlock
var allDownload = document.querySelectorAll('.js-download');

if (allDownload.length > 0) {
  require.ensure([], function() {
    downloadBlock = require('./download');

    for (var i = 0; i < allDownload.length; i++) {
      downloadBlock(allDownload[i]);
    }
  }, 'download');
}


var favoriteBlock
var allFavoriteMark = document.querySelectorAll('.js-favorite');

if (allFavoriteMark.length > 0) {
  require.ensure([], function() {
    favoriteBlock = require('./favorite');

    for (var i = 0; i < allFavoriteMark.length; i++) {
      favoriteBlock(allFavoriteMark[i]);
    }
  }, 'favorite');
}

var friendBlock
var allFriendBlock = document.querySelectorAll('.js-friend');

if (allFriendBlock.length > 0) {
  require.ensure([], function() {
    friendBlock = require('./friend');

    for (var i = 0; i < allFriendBlock.length; i++) {
      friendBlock(allFriendBlock[i]);
    }
  }, 'friend');
}

var commentBlock
var allCommentBlock = document.querySelectorAll('.js-comment');

if (allCommentBlock.length > 0) {
  require.ensure([], function() {
    commentBlock = require('./comment');

    for (var i = 0; i < allCommentBlock.length; i++) {
      commentBlock(allCommentBlock[i]);
    }
  }, 'comment');
}

var rotateBlock
var allRotateBlock = document.querySelectorAll('.js-rotate');

if (allRotateBlock.length > 0) {
  require.ensure([], function() {
    rotateBlock = require('./rotate');

    for (var i = 0; i < allRotateBlock.length; i++) {
      rotateBlock(allRotateBlock[i]);
    }
  }, 'rotate');
}

var resolutionBlock
var allResolutionBlock = document.querySelectorAll('.js-resolution');

if (allResolutionBlock.length > 0) {
  require.ensure([], function() {
    resolutionBlock = require('./resolution');

    for (var i = 0; i < allResolutionBlock.length; i++) {
      resolutionBlock(allResolutionBlock[i]);
    }
  }, 'resolution');
}

var shareBlock
var allShareBlock = document.querySelectorAll('.js-share');

if (allShareBlock.length > 0) {
  require.ensure([], function() {
    shareBlock = require('./share');

    for (var i = 0; i < allShareBlock.length; i++) {
      shareBlock(allShareBlock[i]);
    }
  }, 'share');
}

var searchBlock
var allSearchBlock = document.querySelectorAll('.js-search-suggest');

if (allSearchBlock.length > 0) {
  require.ensure([], function() {
    searchBlock = require('./search');

    for (var i = 0; i < allSearchBlock.length; i++) {
      searchBlock(allSearchBlock[i]);
    }
  }, 'search');
}


let auth = document.querySelector('.js-auth');
if (auth !== null ) {
    require.ensure([], function () {
         require('./auth')(auth);
    }, 'auth');
}